import React from "react";
import ReactDOM from "react-dom";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

var throttled = false;
var delay = 500;

const throttleSetModalCenter = () => {
    if (!throttled) {
        // we're throttled!
        throttled = true;
        // set a timeout to un-throttle
        setTimeout(function () {
            // actual callback action
            setModalCenter();
            throttled = false;
        }, delay);
    }
};

const setModalCenter = () => {
    const el = document.getElementById("modal");

    if (!el) {
        return;
    }

    const modalHeight = el.offsetHeight;
    const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    if (modalHeight < windowHeight) {
        el.classList.add("-center");
    } else {
        el.classList.remove("-center");
    }
};

const Modal = (props) => {
    return props.show ? (
        <ModalBuilder
            cssClass={props.cssClass}
            transparent={props.transparent}
        >
            {props.children}
            {!props.hideClose && (
                <div
                    className="modal-close"
                    onClick={props.onClose}
                >
                    <FontAwesomeIcon icon={faTimesCircle} />
                </div>
            )}
        </ModalBuilder>
    ) : null;
};

class ModalBuilder extends React.Component {
    constructor(props) {
        super(props);
        // Create a div that we'll render the modal into. Because each
        // Modal component has its own element, we can render multiple
        // modal components into the modal container.

        this.el = document.createElement("div");
        this.el.classList.add("modal-overlay");
        this.el.setAttribute("role", "dialog");

        if (props.transparent) {
            this.el.classList.add("-transparent");
        }

        this.resizeObserver = new ResizeObserver(throttleSetModalCenter);
    }

    componentDidMount() {
        // Append the element into the DOM on mount. We'll render
        // into the modal container element (see the HTML tab).
        document.getElementById("modal-root").appendChild(this.el);
        document.body.classList.add("-modal-showing");
        setModalCenter(document.getElementById("modal"));

        this.resizeObserver.observe(document.getElementById("modal"));
        window.addEventListener("resize", throttleSetModalCenter);
    }

    componentWillUnmount() {
        this.resizeObserver.unobserve(document.getElementById("modal"));
        window.removeEventListener("resize", throttleSetModalCenter);
        // Remove the element from the DOM when we unmount
        document.getElementById("modal-root").removeChild(this.el);
        document.body.classList.remove("-modal-showing");
    }

    render() {
        const modalContainer = (
            <div
                id="modal"
                className={classnames("modal", { [this.props.cssClass]: this.props.cssClass })}
            >
                {this.props.children}
            </div>
        );

        // Use a portal to render the children into the element
        return ReactDOM.createPortal(
            // Any valid React child: JSX, strings, arrays, etc.
            modalContainer,
            // A DOM element
            this.el
        );
    }
}

export default Modal;
